export default "__VITE_ASSET__6c991841__"